import { render, staticRenderFns } from "./commonServiceItem.vue?vue&type=template&id=4113171b&"
import script from "./commonServiceItem.vue?vue&type=script&lang=ts&"
export * from "./commonServiceItem.vue?vue&type=script&lang=ts&"
import style0 from "./commonServiceItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports